const APP_SCHEME = "ciety://";

export const EDesktopAppDeeplink = {
  AuthSigninConsume: `${APP_SCHEME}auth-signin-consume`,
  AuthConnectConsume: `${APP_SCHEME}auth-connect-consume`,
} as const;

export type EDesktopAppDeeplink =
  typeof EDesktopAppDeeplink[keyof typeof EDesktopAppDeeplink];
